import { LANGUAGES } from "@/constants/languages";
import { create } from "zustand";

interface LanguageState {
  locale: string;
  translations: Record<string, string>;
  setLanguage: (lang: string) => void;
  setTranslations: (lang: string) => Promise<void>;
}

export const useLanguageStore = create<LanguageState>((set, get) => ({
  locale: LANGUAGES.ES,
  translations: {},
  setLanguage: (lang) => {
    set({ locale: lang });
    get().setTranslations(lang);
  },
  setTranslations: async (lang) => {
    const res = await import(`../app/[locale]/${lang}.json`);
    set({ translations: res.default });
  },
}));
